import { Box, Button, CircularProgress, InputLabel, Typography } from '@mui/material';
import React, { useEffect } from 'react'

import CustomToast from '../../components/Toast/CustomToast';
import { ENDPOINT } from '../../services/endPoints';
import InputController from '../../components/InputController/InputController';
import SelectController from '../../components/SelectController/SelectController';
import { feedbackSchema } from '../../schemas/FeedbackSchema';
import { useForm } from 'react-hook-form';
import useMasterApi from '../../services/useMasterApi';
import useToast from '../../hooks/useToast';
import { yupResolver } from '@hookform/resolvers/yup';

const Feedback = () => {
    const { handleSubmit, control, formState: { errors, isDirty, isValid }, reset } = useForm({
        defaultValues: {
            full_name: "",
            phone_number: "",
            email_id: "",
            comments: "",
            feedback_type: "",
            user_type: "1",
             user_code: "cudo-weff-jhgj-yui"
        },
        resolver: yupResolver(feedbackSchema),
    });
    const { toastMessage, toast, toastType, setToast, showToast } = useToast()
    const { post, data, error, loading } = useMasterApi();



    const onSubmit = (data) => {
        post(ENDPOINT.FEEDBACK, data)
        reset();
    }

    useEffect(() => {
        if (data) {
            if (data.success) {
                showToast("success", "Feedback Sent Successfully")
            }
            if (error) {
                showToast("error", error.data.error)
            }
        }
    }, [data, error])

    const feedbackOptions= [
        {label: "Suggestion", value: "Suggestion"},
        {label: "Complaint", value: "Complaint"},
        {label: "Appreciation", value: "Appreciation"},
        {label: "Others", value: "Others"},
    ]
    return (
        <>
            <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box
                        sx={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "800px", mx: "auto" }}
                    >
                        <Box sx={{ textAlign: "center" }}>
                            <Typography variant="h1" fontWeight="bold" color={(theme) => theme.palette.secondary.main}>
                                Enter your <Box sx={{ display: "inline", color: (theme) => theme.palette.aqua.main }}>Valuable!</Box>
                            </Typography>
                            <Typography sx={{ mt: 1, fontWeight: "600" }} color={(theme) => theme.palette.secondary.main}>
                                Feedback
                            </Typography>
                        </Box>

                        <InputLabel sx={{ fontSize: "1.5rem", color: (theme) => theme.palette.primary.main }}>Any Suggestion?</InputLabel>

                        <SelectController
                            name="feedback_type"
                            label="Feedback Type"
                            control={control}
                            errors={errors}
                            options={feedbackOptions}
                            mainLogin
                        />
                        <InputController
                            name="full_name"
                            label="Full Name"
                            control={control}
                            errors={errors}
                            mainLogin
                        />
                        <InputController
                            name="email_id"
                            label="Email Id"
                            control={control}
                            errors={errors}
                            mainLogin
                        />

                        <InputController
                            name="phone_number"
                            label="Phone Number"
                            control={control}
                            errors={errors}
                            mainLogin
                        />

                        <InputController
                            name="comments"
                            label="Comments"
                            control={control}
                            errors={errors}
                            mainLogin
                        />


                        <Button variant="contained" type="submit" disabled={loading || (!isDirty || !isValid)}>
                            {loading ? <CircularProgress /> : "Send Feedback"}
                        </Button>
                        {toast && <CustomToast
                            open={toast}
                            toastMessage={toastMessage}
                            setToast={setToast}
                            toastType={toastType}
                        />}
                    </Box>
                </form>
            </div>
        </>
    )
}

export default Feedback